/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".enroll-automatic-payment-section[_ngcontent-%COMP%]{position:relative}.enroll-automatic-payment-section[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{background-color:#007ac9;padding:20px;margin:20px}.enroll-automatic-payment-section[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:30px;position:absolute;left:45%;top:-32%}.enroll-automatic-payment-section[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-size:25pt;color:#fff;font-weight:bolder}\n/*# sourceMappingURL=enroll-automatic-payment.component.css.map*/"];
export { styles as styles };
